// extracted by mini-css-extract-plugin
export default {"contentContainerFake":"contentContainerFake___2dLzg","hidden":"hidden___21lEj"};